import Store from 'store/store';
import { sortObjectByOrder } from 'utils/utils';

// const replaceLegacyViewIds = (view, pages) => {
// 	if (view === 'showtimes' && !pages.showtimes && pages.boltShowtimes) {
// 		return 'boltShowtimes';
// 	}
// 	if (view === 'homeEnt' && !pages.homeEnt && pages.boltHomeEnt) {
// 		return 'boltHomeEnt';
// 	}
// 	return view;
// };

export function getPreviewPanelHomeEntData(pageId, options) {
	const { appData, homeEnt } = Store.get();
	const homeEntData = homeEnt['data-' + pageId] || homeEnt.data;
	const homeEntPageData = appData.pages?.[pageId]?.data || {};
	// const previewPanelPageData = appData.pages.boltPreviewPanel?.data || null;
	// let homeEntNeeded = false;
	// if (previewPanelPageData) {
	// 	const enabledViews = (previewPanelPageData?.enabledViews || '').split(',').map(e => replaceLegacyViewIds(e.trim(), appData.pages));
	// 	homeEntNeeded = enabledViews.includes(pageId);
	// }
	// if (!homeEntNeeded) {
	// 	return;
	// }

	let regions = homeEntPageData.regions.toLowerCase().replace(/\s/g, '').split(',');
	const addProductsMultiRegion = homeEntPageData.addProductsMultiRegion || {};
	let extraRegions = Object.keys(addProductsMultiRegion);
	const multiRegion = regions.length > 1 || extraRegions.length;
	const allRegions = [...new Set(regions.concat(extraRegions))].filter(a => a);
	if (!allRegions.length && !multiRegion) {
		allRegions.push('default');
	}
	const regionCustomisations = homeEntPageData.customiseRegion || {};
	regions = sortRegions(allRegions, regionCustomisations);
	let currentRegion = regions[0];
	const regionData = regionCustomisations[currentRegion] || {};

	let formatOrder = ['digital', 'bluRay', 'dvd'].reverse();
	let data = homeEntData;
	if (multiRegion) {
		currentRegion = options?.region || regions.find(region => data?.[region]);
		data = data?.[currentRegion];
	}

	let availFormats = allRegions.reduce((acc, reg) => {
		let dataObj = multiRegion ? homeEntData?.[reg] : homeEntData;
		acc.push(Object.keys(dataObj || {}).filter((format) => Object.keys(dataObj[format]).length));
		return acc;
	}, []).flat().sort((a, b) => formatOrder.indexOf(b) - formatOrder.indexOf(a));

	availFormats = [...new Set(availFormats)];

	const format = availFormats[0];

	if (!data || !format || !data[format]) return;

	const restrictedAvail = homeEnt.restrictedAvailability;
	let foundAvailabilities = getAllAvailabilities(allRegions, multiRegion, homeEntData, format, restrictedAvail);
	let userSelectedAvailabilities = foundAvailabilities;
	let merchants = Object.keys(data[format]).filter(m => {
		if (m === 'undefined') return false;

		// don't render the merchant if it has no products to show within the selected availabilities
		let hasProduct = false;

		userSelectedAvailabilities.forEach(a => {
			if (data[format][m][a] && data[format][m][a].length) hasProduct = true;
		});

		if (userSelectedAvailabilities.includes('comingSoon') && data[format][m].comingSoon) {
			// if the comingSoon has expired and there are other avails for the merchant,
			// we don't want to show it under comingSoon
			if (!(data[format][m].comingSoon.expired && (Object.keys(data[format][m]).length > 1))) {
				hasProduct = true;
			}
			// we can still show it under comingSoon if it only has one other property, which is 'order'
			if (data[format][m].comingSoon.expired && (Object.keys(data[format][m]).length === 2) && !!data[format][m].order) {
				hasProduct = true;
			}
		}

		// If merchant has an active 'coming soon', it should not appear in any other availability
		if (data[format][m].comingSoon && !data[format][m].comingSoon.expired && !userSelectedAvailabilities.includes('comingSoon')) {
			hasProduct = false;
		}

		return hasProduct;
	}).sort((a, b) => {
		if (data[format][a].order && data[format][b].order) {
			return (data[format][a].order - data[format][b].order);
		}
		if (data[format][a].order) {
			return -1;
		}
		if (data[format][b].order) {
			return 1;
		}
		return a.localeCompare(b);
	});

	Store.get().set({
		['previewPanelHomeEnt-' + (options?.storeName || pageId)]: {
			currentRegion,
			merchants,
			userSelectedAvailabilities,
			format,
			data,
			regionData
		}
	});
}

function getAllAvailabilities(allRegions, multiRegion, homeEntData = {}, selectedFormat, restrictedAvail, ) {
	if (restrictedAvail) {
		return [restrictedAvail];
	}
	const availabilityOrder = ['stream', 'rent', 'buy', 'preOrder', 'comingSoon'].reverse();
	const foundAvailabilities = allRegions.reduce((acc, reg) => {
		let dataObj = (multiRegion ? homeEntData[reg] : homeEntData) || {};
		const currentMerchants = Object.keys(dataObj[selectedFormat] || {});
		let availsForCurrentMerchants = currentMerchants.map(m => {
			const availsForSingleMerchant = Object.keys(dataObj[selectedFormat][m]).filter(avail => {
				const isComingSoon = avail === 'comingSoon';
				const comingSoonExpired = dataObj[selectedFormat][m].comingSoon && dataObj[selectedFormat][m].comingSoon.expired;
				if (isComingSoon && !comingSoonExpired) return true;
				if (dataObj[selectedFormat][m].comingSoon && !comingSoonExpired) return false;
				const potentialProducts = dataObj[selectedFormat][m][avail];
				if (!Array.isArray(potentialProducts)) return false;
				if (!potentialProducts.length) return false;
				return true;
			});
			// If there is no other availability for the merchant, show coming soon avail even if expired
			if (availsForSingleMerchant.length < 1 && dataObj[selectedFormat][m].comingSoon) {
				availsForSingleMerchant.push('comingSoon');
			}
			return availsForSingleMerchant;
		}).flat();
		acc.push(availsForCurrentMerchants);
		return acc;
	}, []).flat();

	return [...new Set(foundAvailabilities)].sort((a, b) => availabilityOrder.indexOf(b) - availabilityOrder.indexOf(a));
}

function sortRegions(allRegions, regionCustomisations) {
	const regionOrder = sortObjectByOrder(regionCustomisations, (val, key) => key ).reverse();
	const ipGeoCode = Store.get().client?.geo.countryCode;

	const sortedRegions = allRegions.sort((a, b) => {
		if (a === ipGeoCode) return -1;
		if (b === ipGeoCode) return 1;
		if (regionOrder && regionOrder.length) {
			return regionOrder.indexOf(b) - regionOrder.indexOf(a);
		}
		return 0;
	});

	return sortedRegions;
}